import React, { useEffect, useRef, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { NAV, ORG } from "../data/site";
import { Mark } from "./icons";
import { PillLink } from "./shared";

function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const burger = useRef(null);
  const { pathname } = useLocation();
  // On the home page the header floats over the hero photo until you scroll.
  const overPhoto = pathname === "/" && !scrolled && !open;

  useEffect(() => setOpen(false), [pathname]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // While the menu is open: lock the page, close on Escape or on resize to desktop.
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") { setOpen(false); burger.current.focus(); }
    };
    const mq = window.matchMedia("(min-width: 900px)");
    const onMq = (e) => e.matches && setOpen(false);
    document.documentElement.classList.add("menu-open");
    document.addEventListener("keydown", onKey);
    mq.addEventListener("change", onMq);
    return () => {
      document.documentElement.classList.remove("menu-open");
      document.removeEventListener("keydown", onKey);
      mq.removeEventListener("change", onMq);
    };
  }, [open]);

  return (
    <header className={`site-head${scrolled ? " is-scrolled" : ""}${overPhoto ? " over-photo" : ""}${open ? " is-open" : ""}`}>
      <a className="skip-link" href="#main">Skip to content</a>
      <div className="head-bar">
        <Link className="brand" to="/" aria-label="EMANAC home">
          <Mark />
          <b>EMANAC</b>
        </Link>

        <nav className="nav" aria-label="Main">
          {NAV.map((n) => <NavLink key={n.to} to={n.to} end={n.to === "/"}>{n.label}</NavLink>)}
        </nav>

        <PillLink to="/joinUs" className="head-cta">Join EMANAC</PillLink>

        <button
          ref={burger}
          className="burger"
          type="button"
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          aria-controls="site-menu"
          onClick={() => setOpen((o) => !o)}
        >
          <i></i><i></i>
        </button>
      </div>

      <div className="menu" id="site-menu" data-open={open || undefined} aria-hidden={!open}>
        <nav aria-label="Mobile">
          {[...NAV, { to: "/joinUs", label: "Join us" }].map((n, i) => (
            <NavLink key={n.to} to={n.to} end={n.to === "/"} style={{ "--d": i }} tabIndex={open ? 0 : -1}>
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="menu-foot" style={{ "--d": NAV.length + 2 }}>
          <a href={`mailto:${ORG.email}`} tabIndex={open ? 0 : -1}>{ORG.email}</a>
          <a href={ORG.phoneHref} tabIndex={open ? 0 : -1}>{ORG.phone}</a>
        </div>
      </div>
    </header>
  );
}

export default Header;
